const photosTemplate = require('20220101/templates/widgets/gallery/photos.hbs');
const indexTemplate = require('20220101/templates/widgets/gallery/index.hbs');
import widgetMixin from "./widget-mixin.js";

const DEFAULTS = {
  numPhotos: "28"
}

class GalleryWidget extends widgetMixin(HTMLElement) {
  constructor() {
    super();

    this.DEFAULTS = DEFAULTS;
    this.photos = [];
    this.per = this.numPhotos;
  }

  bindEvents() {
    if (!this.loadMoreLink) { return }

    this.loadMoreLink.addEventListener("click", (e) => {
      e.preventDefault();
      this.fetchPhotos();
    });
  }

  beforeFetch() {
    super.beforeFetch();
    this.hideLoadMoreLink();
    this.showLoadingSpinner();
  }

  afterFetch() {
    super.afterFetch();
    this.hideLoadingSpinner();

    if (this.page) { this.showLoadMoreLink() }
  }

  beforeRerender() {
    if (this.photos.length > this.numPhotos) {
      this.photos = this.photos.slice(0, this.numPhotos);
    }

    if (this.photos.length < this.numPhotos) {
      this.photos = [];
      this.fetchPhotos();
    }
  }

  render() {
    this.per = this.numPhotos;
    this.page = 1;

    this.renderIndex();

    if (this.initialized) { this.beforeRerender() }

    this.bindEvents();

    this.appendPhotos(this.photos);
  }

  renderIndex() {
    const renderedIndex = indexTemplate({ preferences: this.preferences, assetHost: this.settings.assetHost, uuid: this.uuid });
    this.shadow.innerHTML = renderedIndex;
    this.appendCustomCSS();
  }

  appendPhotos(photos) {
    const renderedPhotos = photosTemplate({photos, preferences: this.preferences});
    this.shadow.querySelector('.l2h-photos').insertAdjacentHTML('beforeend', renderedPhotos);
    this.renderHeader();
  }

  showLoadMoreLink() {
    this.loadMoreLink.classList.remove("l2h-hidden");
  }

  hideLoadMoreLink() {
    this.loadMoreLink.classList.add("l2h-hidden");
  }

  showLoadingSpinner() {
    this.spinner.classList.remove("l2h-hidden");
  }

  hideLoadingSpinner() {
    this.spinner.classList.add("l2h-hidden");
  }

  get loadMoreLink() {
    return this.shadow.querySelector('[data-l2h-load-more]');
  }

  get spinner() {
    return this.shadow.querySelector(".l2h-loading-spinner");
  }
}

customElements.define('l2h-gallery-widget', GalleryWidget);
